export default __webpack_public_path__ + "static/media/propertyshell_bg.ceb5669d.png";